"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.6651 13.5356L36.4644 9.33489C35.9977 8.86814 35.0642 8.86814 34.3641 9.33489L26.196 17.5029C24.5624 19.1365 22.6954 20.07 20.5951 20.3034C16.3944 21.0035 12.4271 23.1039 9.39323 26.1377L1.2252 34.3057C-0.408401 35.9393 -0.408401 38.7398 1.2252 40.6068L9.39323 48.7748C11.0268 50.4084 13.8273 50.4084 15.6943 48.7748L23.8623 40.6068C26.8961 37.5729 28.7631 33.839 29.4632 29.6383C29.6966 27.5379 30.8635 25.4376 32.2637 24.0373C32.4971 23.804 40.1984 16.1027 40.4317 15.8693C41.1319 14.9358 41.1319 14.0023 40.6651 13.5356ZM13.8273 46.6744C13.3606 47.1412 12.4271 47.1412 11.727 46.6744L3.55893 38.5064C3.09218 38.0397 3.09218 37.1062 3.55893 36.4061L4.49242 35.4726L14.7608 45.741L13.8273 46.6744ZM21.9953 38.5064L16.8611 43.6406L6.59277 33.3722L11.4936 28.0047C12.6604 26.8378 13.8273 25.9043 15.2275 25.2042L24.7958 34.7725C23.8623 36.1727 22.9288 37.3396 21.9953 38.5064ZM30.3967 21.7036C28.2964 23.804 27.1295 26.1377 26.6628 28.9382C26.4294 29.8716 26.196 30.8051 25.9627 31.7386L18.028 23.804C18.9615 23.804 19.895 23.5706 21.0618 23.3372C23.8623 22.8705 26.4294 21.7036 28.2964 19.6033L31.3302 16.5694L33.4306 18.6698L30.3967 21.7036ZM35.5309 16.5694L33.4306 14.4691L35.5309 12.3687L37.6313 14.4691L35.5309 16.5694Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.9662 3.03384C46.4994 2.56709 45.5659 2.56709 44.8658 3.03384L41.832 6.06768C41.3652 6.53442 41.3652 7.46791 41.832 8.16803C42.2987 8.63477 43.2322 8.63477 43.9323 8.16803L46.9662 5.13419C47.4329 4.66744 47.4329 3.73396 46.9662 3.03384Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.5998 11.6686H45.5659C44.8658 11.6686 44.1657 12.3687 44.1657 13.0688C44.1657 13.769 44.8658 14.4691 45.5659 14.4691H48.5998C49.2999 14.4691 50 13.769 50 13.0688C50 12.3687 49.2999 11.6686 48.5998 11.6686Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.9312 0C36.231 0 35.5309 0.700117 35.5309 1.40023V4.43407C35.5309 5.13419 36.231 5.83431 36.9312 5.83431C37.6313 5.83431 38.3314 5.13419 38.3314 4.43407V1.40023C38.3314 0.700117 37.6313 0 36.9312 0Z",
    fill: fill
  }));
};

exports["default"] = _default;